// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file mars/mars_task_common.proto (package vsmr.mars.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message vsmr.mars.v1.NamedValue
 */
export class NamedValue extends Message<NamedValue> {
  /**
   * Original MARS variable name / key
   * e.g. "v_da_p", "v_da_tempf", "j_da_mflowj", "icv_da_*", "m_dt"
   * For minor edit, this can be the user-defined item name/key.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: double value = 2;
   */
  value = 0;

  /**
   * @generated from field: string unit = 3;
   */
  unit = "";

  constructor(data?: PartialMessage<NamedValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.mars.v1.NamedValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NamedValue {
    return new NamedValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NamedValue {
    return new NamedValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NamedValue {
    return new NamedValue().fromJsonString(jsonString, options);
  }

  static equals(a: NamedValue | PlainMessage<NamedValue> | undefined, b: NamedValue | PlainMessage<NamedValue> | undefined): boolean {
    return proto3.util.equals(NamedValue, a, b);
  }
}

/**
 * @generated from message vsmr.mars.v1.NamedValues
 */
export class NamedValues extends Message<NamedValues> {
  /**
   * @generated from field: repeated vsmr.mars.v1.NamedValue values = 1;
   */
  values: NamedValue[] = [];

  constructor(data?: PartialMessage<NamedValues>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.mars.v1.NamedValues";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: NamedValue, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NamedValues {
    return new NamedValues().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NamedValues {
    return new NamedValues().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NamedValues {
    return new NamedValues().fromJsonString(jsonString, options);
  }

  static equals(a: NamedValues | PlainMessage<NamedValues> | undefined, b: NamedValues | PlainMessage<NamedValues> | undefined): boolean {
    return proto3.util.equals(NamedValues, a, b);
  }
}

/**
 * @generated from message vsmr.mars.v1.ObjectIdList
 */
export class ObjectIdList extends Message<ObjectIdList> {
  /**
   * @generated from field: repeated int32 object_ids = 1;
   */
  objectIds: number[] = [];

  constructor(data?: PartialMessage<ObjectIdList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.mars.v1.ObjectIdList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ObjectIdList {
    return new ObjectIdList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ObjectIdList {
    return new ObjectIdList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ObjectIdList {
    return new ObjectIdList().fromJsonString(jsonString, options);
  }

  static equals(a: ObjectIdList | PlainMessage<ObjectIdList> | undefined, b: ObjectIdList | PlainMessage<ObjectIdList> | undefined): boolean {
    return proto3.util.equals(ObjectIdList, a, b);
  }
}

